if (!customElements.get('compare-table-selects')) {
  class CompareTableSelects extends HTMLElement {
    constructor() {
      super();

      this.selects = this.querySelectorAll('.compare_table__content-action-select');

      this.selects.forEach((select) => {
        select.addEventListener('change', () => this.changeSelect(select));
      });
    }

    changeSelect(select) {
      const section = select.closest('.compare-table');
      const oldContent = section.querySelectorAll(`[data-compare="${select.dataset.prevValue}"]`);
      const newContent= section.querySelectorAll(`[data-compare="${select.value}"]`);

      select.dataset.prevValue = select.value;

      oldContent.forEach((item) => {
        item.classList.remove('compare-active');

        if (select.classList.contains('compare_table__content-action-select--first') && item.classList.contains('compare-active--first')) {
          item.classList.remove('compare-active--first');
        }
      });

      newContent.forEach((item) => {
        if (select.classList.contains('compare_table__content-action-select--first')) {
          item.classList.add('compare-active', 'compare-active--first');
        } else {
          item.classList.add('compare-active');
        }
      });

      this.changeAvaialbleOptions();
    }

    changeAvaialbleOptions() {
      const selectedData = [];

      this.selects.forEach((select) => {
        selectedData.push(select.value);
      });

      this.selects.forEach(() => {
        const options = this.querySelectorAll(`option`);

        options.forEach((option) => {
          option.setAttribute('disabled', 'disabled');
        });

        options.forEach((option) => {
          if (!selectedData.includes(option.value)) {
            option.removeAttribute('disabled');
          }
        });
      });
    };
  }

  customElements.define('compare-table-selects', CompareTableSelects);
}
